/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".accent-color[_ngcontent-%COMP%]{color:#555}.warn-color[_ngcontent-%COMP%]{color:#f44336}.aec-i[_ngcontent-%COMP%]{background:url(/assets/images/bike.png) 0 0/contain no-repeat;width:120px;height:65px;margin:20px auto}.aec-t[_ngcontent-%COMP%]{font-weight:700;font-size:20px;text-align:center;margin:50px 0}.aec-l[_ngcontent-%COMP%]{text-align:center;margin-bottom:50px}.aec-l-t[_ngcontent-%COMP%]{color:#aaaab1}.aec-l-l[_ngcontent-%COMP%]     span{border-bottom:1px solid #000}"];
export { styles as styles };
